export default "__VITE_ASSET__XohKjo6$__"